export default "__VITE_ASSET__6dd71433__"